import { Control, Controller } from 'react-hook-form';
import { Values } from '@/presentation/components/views/WithdrawLiquidity/types';

export const PercentField = ({ control }: { control: Control<Values> }) => {
  return (
    <Controller
      name="percent"
      control={control}
      render={({ field }) => (
        <div className="bg-gray-50 rounded space-y-2">
          <h2 className="font-medium">{'Amount'}</h2>
          <div className="flex justify-between">
            <div className="text-lg">{`${field.value}%`}</div>
            <div className="flex space-x-2">
              {['25', '50', '75', '100'].map((value) => (
                <button
                  key={value}
                  type="button"
                  className={`py-2 px-4 border rounded-lg text-sm font-medium ${
                    field.value === value
                      ? 'bg-pink-500 text-gray-50 border-pink-500'
                      : 'border-gray-200 hover:bg-pink-50 hover:border-pink-500 hover:text-pink-500'
                  }`}
                  onClick={() => field.onChange(value)}
                >
                  {value === '100' ? 'MAX' : `${value}%`}
                </button>
              ))}
            </div>
          </div>
          <div>
            <input
              type="range"
              min="0"
              max="100"
              step="1"
              {...field}
              className="w-full"
            />
          </div>
        </div>
      )}
    />
  );
};
